import script from "./UiTable.vue?vue&type=script&lang=js"
export * from "./UiTable.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__